<template lang="pug">
  section.section
    .scroll-table.table-border
      b-table(
        :data="acceptingOrderItems"
        :loading="loading"
        narrowed
        hoverable
        striped
        paginated
        per-page="100"
        )
        template(slot-scope="props")
          b-table-column(field="No." label="No." width="50")
            | {{ props.row.i }}
          b-table-column(field="isbn" label="書籍名 : ISBN" width="400")
            | {{ bookName(props.row.isbn) }}
          b-table-column(field="agency_code" label="帳合" width="100")
            | {{ agencyName(props.row.agency_code) }}
          b-table-column(field="agency_shop_code" label="取次書店コード" width="110")
            | {{ props.row.agency_shop_code }}
          b-table-column(field="shop_name" label="書店名" width="200")
            | {{ shopName(props.row.agency_code, props.row.agency_shop_code, props.row.book_shop_name) }}
          b-table-column(field="order_number" label="発注数" width="60")
            | {{  props.row.order_number}}
          b-table-column(field="order_route_id" label="受注経路" width="70")
            | {{ orderRouteName(props.row.order_route_id) }}
          b-table-column(field="order_route_id" label="出荷属性" width="120")
            | {{ deliverTypeName(props.row.deliver_type_id) }}
          b-table-column(field="bansen" label="番線" width="70")
            | {{ props.row.bansen }}
          b-table-column(field="sales_person_id" label="営業担当" width="70")
            | {{ salesPersonName(props.row.sales_person_id) }}
          b-table-column(field="kyakutyu_memo" label="客注メモ" width="300")
            | {{ props.row.kyakutyu_memo }}
          b-table-column(field="bibo" label="備考" width="300")
            | {{ props.row.bibo }}
          b-table-column(field="shop_person" label="書店担当" width="100")
            | {{ props.row.shop_person }}
          b-table-column(field="accepting_date" label="受注日" width="100")
            | {{ props.row.accepting_date | moment("YYYY/MM/DD") }}
    .field.is-grouped
      .control
        button(@click="backToNew" class="button is-primary control back-button")
          b-icon(pack="fas" custom-class="fa-sm fa-chevron-left")
          span 戻る
      .control
        button(@click="submit" class="button is-danger control submit-button" id="first-submit-button")
          b-icon(pack="fas" custom-class="fa-sm fa-plus")
          span 登録する
      .control
        span(class="button is-light") {{ "合計 " + sumOrderNumber() + "冊" }}
</template>

<script>
  export default {
    name: 'accepting-orders-confirm-table',
    data() {
      return {

      }
    },
    props: {
      acceptingOrder: {
        type: Object,
        required: true
      },
      acceptingOrderItems: {
        type: Array,
        required: true
      },
      action_name: "",
      loading: false,
    },
    computed: {
      books(){  return this.$store.getters['Books/records'] },
      accepting_order_routes(){ return this.$store.getters['AcceptingOrderRoutes/records'] },
      agencies(){ return this.$store.getters['Agencies/records'] },
      final_book_shop_agencies(){ return this.$store.getters['FinalBookShopAgencies/records'] },
      final_book_shops(){ return this.$store.getters['FinalBookShops/records'] },
      shop_people(){ return this.$store.getters['ShopPeople/records'] },
      deliver_types(){ return this.$store.getters['DeliverTypes/records'] },
      sales_people(){ return this.$store.getters['SalesPeople/records'] },
    },
    methods: {
      bookName(value){
        if (!value) return ''
        let a = this.books.filter(book => book.isbn == value)
        return a.length > 0 ? `${a[0].name} : ${a[0].isbn}` : ''
      },
      shopName(agency_code, agency_shop_code, book_shop_name){
        if(book_shop_name) return book_shop_name
        if (!agency_code) return ''
        let tmp = this.final_book_shop_agencies
            .filter(final_book_shop_agency => final_book_shop_agency.agency_code == agency_code && final_book_shop_agency.agency_shop_code == agency_shop_code)
        return tmp.length > 0 ? tmp[0].name : ''
      },
      agencyName(agency_code){
        if (!agency_code) return ''
        let tmp = this.agencies
            .filter(agency => agency.code == agency_code)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      orderRouteName(id){
        if (!id) return ''
        let tmp = this.accepting_order_routes
            .filter(route => route.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      deliverTypeName(id){
        if (!id) return ''
        let tmp = this.deliver_types
            .filter(type => type.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      salesPersonName(id){
        if (!id) return ''
        let tmp = this.sales_people
            .filter(type => type.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      sumOrderNumber() {
        let sum = 0
        this.acceptingOrderItems.forEach((item) => {
          sum += Number(item.order_number)
        })
        return sum
      },
      backToNew() {
        this.$emit("confirming", false)
      },
      createParams() {
        let params = null
        if(this.action_name == "new") {
          params = {
            accepting_order: {
              confirming: "1",
              sid: this.acceptingOrder.sid,
              daily_count: this.acceptingOrder.daily_count,
              book_types: this.acceptingOrder.book_types,
              order_number: this.acceptingOrder.order_number,
              delivered_number: this.acceptingOrder.delivered_number,
              accepting_order_items_attributes: this.acceptingOrderItems
            }
          }
        } else {
          params = {
            accepting_order: {
              confirming: "1",
              accepting_order_items_attributes: this.acceptingOrderItems
            }
          }
        }
        return params
      },
      submitRequest(){
        var method = this.action_name == "new" ? 'post' : 'put'
        var url = this.action_name == "new" ? `/api/v1/accepting_orders.json` : `/api/v1/accepting_orders/${this.accepting_order_id}.json`
        var params = this.createParams(this.action_name)
        return this.$http({ method: method, url: url, data: params })
      },
      submit(){
        this.disableButtons()
        this.loading = true
        this.submitRequest().then(({data}) => {
          this.loading = false
          window.location.href = `/users/accepting_orders?registered=true`
        })
        .catch((error) => {
          this.loading = false
          throw error
        })
      },
      disableButtons() {
        document.querySelectorAll(".submit-button").forEach(submitButton => {
          submitButton.disabled = true
        })
        document.querySelectorAll(".back-button").forEach(backButton => {
          backButton.disabled = true
        })
      }
    },
    created() {
      this.$store.dispatch('FinalBookShops/fetch', 'final_book_shops')
    }
  }
</script>